import React from 'react';
import c from 'classnames';

import Themes from './Themes';
import ReadTime from './ReadTime';
import Department from './Department';
import PublicationDate from './PublicationDate';
import Type from './Type';

import './style.scss';

interface ArticleMetadataSubComponents {
  PublicationDate: typeof PublicationDate;
  ReadTime: typeof ReadTime;
  Department: typeof Department;
  Themes: typeof Themes;
  Type: typeof Type;
}

export interface ArticleMetadataProps {
  className?: string;
}

const ArticleMetadata: React.FC<ArticleMetadataProps> & ArticleMetadataSubComponents = (props) => {
  const {
    className,
    children,
  } = props;

  const classNames = c('ArticleMetadata', className);

  return (
    <div className={classNames}>
      {children}
    </div>
  );
};

ArticleMetadata.PublicationDate = PublicationDate;
ArticleMetadata.ReadTime = ReadTime;
ArticleMetadata.Department = Department;
ArticleMetadata.Themes = Themes;
ArticleMetadata.Type = Type;

export default ArticleMetadata;
